import http from "./http"
import { Fixture } from "../models/fixture"
import { UpdateFixturesDTO } from "../models/league"

class FixtureService {
  private readonly baseUrl = "/fixture"

  async readFixture(id: string) {
    const { data } = await http.get<Fixture>(`${this.baseUrl}/${id}`)
    return data
  }

  async updateFixture(fixtureId: string, dto: UpdateFixturesDTO) {
    await http.put(`${this.baseUrl}/${fixtureId}`, dto)
  }
}

export default new FixtureService()
